import { useCallback, useState } from "react"
import { TimelineResourceLabelContent } from "../calendar/fullCalendarTypes"
import { useResourceLabelSharedContext } from "../context/ResourceLabelContext"
import { ResourceCalendarLabelContent } from "./ResourceCalendarLabelContent"

export type ResourceLabelProps = Readonly<{
    resource: TimelineResourceLabelContent["resource"]
}>

export function ResourceLabel({ resource }: ResourceLabelProps) {
    const [isSelectionPending, setIsSelectionPending] = useState(false)

    const {
        isLoadingEvents,
        isLocked,
        selectedResourceIdsSet,
        eventsLoadingNativeTitle,
        searchRegex,
        toggleResourceSelection: executeToggle,
        handleOpenDetails,
    } = useResourceLabelSharedContext()

    const isChecked = selectedResourceIdsSet.has(resource.id)

    const toggleResourceSelection = useCallback(
        async (resourceId: string) => {
            setIsSelectionPending(true)
            try {
                await executeToggle(resourceId)
            } finally {
                setIsSelectionPending(false)
            }
        },
        [executeToggle],
    )

    return (
        <ResourceCalendarLabelContent
            isChecked={isChecked}
            resource={resource}
            searchRegex={searchRegex}
            toggleResourceSelection={toggleResourceSelection}
            handleOpenDetails={handleOpenDetails}
            isLocked={isLocked}
            isEventsLoading={isLoadingEvents}
            isSelectionPending={isSelectionPending}
            eventsLoadingNativeTitle={eventsLoadingNativeTitle}
        />
    )
}
